import createBootError from 'owa-shared-start/lib/createBootError';
import { createBaseEvent } from 'owa-shared-start/lib/createBaseEvent';
import { createStatusErrorMessage } from 'owa-shared-start/lib/createStatusErrorMessage';
import { getServerErrorDiagnostics } from 'owa-shared-start/lib/getServerErrorDiagnostics';
import { lazyPostSignal } from 'mini-start-analytics';
import { postLanguageTimeZone } from 'owa-shared-start/lib/postLanguageTimeZone';
import type { IExtendedTelemetryItem } from '@microsoft/1ds-core-js';
import type ErrorDiagnostics from 'owa-shared-start/lib/interfaces/ErrorDiagnostics';
import type { BootError } from 'owa-shared-start-types';

export async function languagePostOnBootError(
    emailAddress?: string,
    authToken?: string
): Promise<void> {
    try {
        const response = await postLanguageTimeZone(emailAddress, authToken);
        const owaError = response.headers.get('X-OWA-Error');

        if (owaError) {
            throw new Error(owaError);
        } else if (response.status >= 400) {
            throw createStatusErrorMessage(response);
        }

        // Log success event to Aria
        await lazyPostSignal.importAndExecute(createLangPostEvent('langpost_success'));
    } catch (e) {
        // Log failed event to Aria
        const langPostError: BootError = createBootError(
            e,
            'LangPost',
            window.location.pathname,
            e.status
        );
        await lazyPostSignal.importAndExecute(
            createLangPostEvent('langpost_error', getServerErrorDiagnostics(langPostError))
        );
    }
}

function createLangPostEvent(
    eventName: string,
    errorDiagnostics?: ErrorDiagnostics
): Promise<IExtendedTelemetryItem[]> {
    // @ts-ignore - The interface don't match due to ids resolution.
    return Promise.resolve([createBaseEvent(eventName, errorDiagnostics)]);
}
